
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionPaymentViewPromotionMarketingViewFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionPaymentViewPromotionMarketingView"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"header"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":141}};
    doc.loc.source = {"body":"fragment SubscriptionPaymentViewPromotionMarketingViewFields on SubscriptionPaymentViewPromotionMarketingView {\n  header\n  image\n  message\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
